module.exports = __webpack_public_path__ + "static/media/mobile_trainee_tm.d7109e17.svg";